import React, { useState, useEffect } from "react";
import moment from "moment";

const Timer = ({ start }) => {
  const [time, setTime] = useState("00:00:00");

  useEffect(() => {
    const timer = setInterval(
      () => setTime(moment.utc(Date.now() - start).format("HH:mm:ss")),
      1000
    );

    return () => {
      clearInterval(timer);
    };
  }, [start]);

  return <span>{time}</span>;
};

export default Timer;
